import React from 'react';
import { Card } from '@cp/ds/src/components/card';
import { Typography } from '@cp/ds/src/components/typography';
import { Divider } from '@cp/ds/src/components/divider';
import { styled } from '@cp/ds/src/theme';
import { useTitle } from '@cp/entities/vacancy';
import { useAddress, useReplies } from '../../model';
import { VacancyCardProps } from './model';
import { Tokens, name } from './const';
import { Parameters } from './parameters';
import { CreatedAt } from './createdAt';
import { Replied } from './replied';
import { Description } from './description';
import { Footer } from './footer';
import { Address } from './address';
import { Viewed } from './viewed';
import { CardHeader } from './header';

const StyledCard = styled(Card, { name })(({ theme }) => ({
  borderRadius: '24px',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1.5),
  gap: theme.spacing(0.75),
  backgroundColor: Tokens.backgroundColor(),
  borderColor: Tokens.borderColor(),
}));

export const VacancyCard: React.FC<VacancyCardProps> = ({
  width = '100%',
  viewed,
  replied,
  hotBadge,
  data,
  url,
  footer,
  disableInfo,
  ...props
}) => {
  const title = useTitle(data);
  const replies = useReplies(data);
  const address = useAddress(data, { enableJSX: true });

  const status = replied ? (
    <Replied data={data} />
  ) : viewed ? (
    <Viewed data={data} />
  ) : (
    <CreatedAt data={data} sx={{ mb: { xs: 0, md: 0.5 } }} />
  );

  return (
    <StyledCard data-itemid={data.id} width={width} {...props}>
      <CardHeader hotBadge={hotBadge} onTitleClick={props.onTitleClick} status={status} title={title} url={url} />
      <Address disableInfo={disableInfo}>{address}</Address>
      <Parameters data={data} />

      <Divider />

      <Description sx={{ filter: disableInfo ? 'blur(7px)' : 'none', pointerEvents: disableInfo ? 'none' : 'all' }}>
        {data.translation?.description ?? ''}
      </Description>
      <Footer>
        {replies ? (
          <Typography sx={{ color: 'gray dark' }} variant="caption">
            {replies}
          </Typography>
        ) : null}
        {footer}
      </Footer>
    </StyledCard>
  );
};
export default VacancyCard;
